import { Box } from "arkh";
import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { TeamIconCircle } from "../../../../../../components/mobile/TeamIconCircle";
import {
  ListSectionHeader,
  ListSectionHeaderTitle,
} from "../../../../../../components/atoms/ListSectionHeader";
import { RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion$key } from "./__generated__/RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion.graphql";

export function RoutineSectionVersionSectionHeaderContent(props: {
  section: RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion$key;
}) {
  const data = useFragment(
    graphql`
      fragment RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion on RoutineSectionVersion {
        id
        title
        section {
          id
          assignedTeam {
            name
            ...TeamIconCircleComponent_Team
          }
        }
      }
    `,
    props.section
  );

  const title = useMemo(
    () =>
      data.title !== null && data.title.length > 0
        ? data.title
        : (data.section.assignedTeam?.name ?? null),
    [data.section.assignedTeam?.name, data.title]
  );

  if (title === null) {
    return null;
  }

  return (
    <ListSectionHeader>
      {data.section.assignedTeam ? (
        <Box spaceRight="small">
          <TeamIconCircle team={data.section.assignedTeam} size="smallMedium" />
        </Box>
      ) : null}
      <ListSectionHeaderTitle>{title}</ListSectionHeaderTitle>
    </ListSectionHeader>
  );
}
